module.exports = __webpack_public_path__ + "img/Wilson.69b4eb13.jpeg";